var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show === 0)?_c('Notice',{attrs:{"new-title":_vm.noticeTitle}}):(_vm.show === 1)?_c('bGround',{attrs:{"title":_vm.title,"bg":_vm.bg,"bgVideo":_vm.bgVideo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }